module.exports = __webpack_public_path__ + "static/kimberly-hardaway-hero-small-bd9f2964c8c4e057e8aa978bd7febe09.jpg";